var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("user-limit"),
      _vm._v(" "),
      _c("SignalR", { attrs: { state: _vm.state } }),
      _vm._v(" "),
      _c(
        "nav",
        { staticClass: "navbar navbar-expand-lg navbar-dark kanban-navbar" },
        [
          _c(
            "a",
            { staticClass: "navbar-brand", attrs: { href: _vm.baseurl } },
            [
              _c("i", {
                staticClass: "fas fa-arrow-circle-left",
                attrs: { title: _vm.$t("kanbanBackToMenu") }
              })
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse",
              attrs: { id: "navbarSupportedContent" }
            },
            [
              _c("ul", { staticClass: "navbar-nav mr-auto" }, [
                _c("li", { staticClass: "nav-item mx-1 active" }, [
                  _c("img", {
                    attrs: {
                      width: "40px",
                      src: _vm.baseurl + "dist/img/revocheck-button-48px.png"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "nav-item mx-1" },
                  [
                    _c("search", {
                      attrs: { suggestions: _vm.suggestions },
                      on: { search: _vm.onSearch }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.canSeeAssignedCards
                  ? _c("li", { staticClass: "nav-item mx-1" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          on: {
                            click: function($event) {
                              return _vm.$refs.list.$refs.modalContainer.openAssignedCards()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "kanban.assignedCards.menu.listAssignedCards"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "nav-item mx-1" },
                  [
                    _c("organigram-modal", {
                      ref: "organigramModal",
                      attrs: { modalId: "organigramModal1" },
                      on: { "account-selected": _vm.onAccountSelected }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: {
                          "data-toggle": "modal",
                          "data-target": "#organigramModal1"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("txtAccount")) +
                            "\n                    "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "nav-item mx-1" },
                  [
                    !_vm.state.archived
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-danger",
                              on: {
                                click: function($event) {
                                  _vm.state.archived = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("kanbanArchiveClosed")))]
                          )
                        ]
                      : [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-success",
                              on: {
                                click: function($event) {
                                  _vm.state.archived = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("kanbanArchiveOpen")))]
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "nav-item mx-1" },
                  [_c("user-settings-button", { attrs: { state: _vm.state } })],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "navbar-nav ml-auto align-items-center" },
                [
                  _vm.isFireProtection
                    ? _c("li", { staticClass: "nav-item mx-1" }, [
                        _c("span", { staticClass: "badge badge-danger" }, [
                          _vm._v(_vm._s(_vm.$t("fireProtectionBadge")))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("li", { staticClass: "nav-item mx-1" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        attrs: {
                          href: _vm.baseurl + "manager/user/" + _vm.userid
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("kanbanHello") + " " + _vm.username + "!"
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "nav-item mx-1" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        attrs: { href: _vm.baseurl + "manager/logout" }
                      },
                      [_vm._v(_vm._s(_vm.$t("kanbanLogout")))]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("kanban-list", {
        ref: "list",
        attrs: { state: _vm.state },
        on: { reload: _vm.reloadAll }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }